<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const card = `
    <div class="rounded border border-light max-w-lg mx-auto">
      <div class="p-4 xl:p-6 space-y-4">
        <h3 class="heading heading-3">Card Title</h3>
        <p class="copy">Enabling teams to create high-quality products and experiences faster for our customers.</p>
      </div>

      <hr class="divider"/>

      <div class="p-4 xl:p-6 space-x-2">
        <button class="button button-primary-dark">Get a quote</button>
        <button class="button button-secondary-dark">More info</button>
      </div>
    </div>
  `;

  const footerlessCard = `
    <div class="rounded border border-light max-w-lg mx-auto">
      <div class="p-4 xl:p-6 space-y-4">
        <h3 class="heading heading-3">Card Title</h3>
        <p class="copy">Enabling teams to create high-quality products and experiences faster for our customers.</p>
        <a href="#" class="link inline-block">Find out more</a>
      </div>
    </div>
  `;

  const imageCard = `
    <div class="rounded border border-light max-w-lg mx-auto">
      <div class="relative">
        <span class="tag tag-info absolute top-2 right-2">Example tag</span>
        <img src="https://via.placeholder.com/900x600" alt="Placeholder" loading="lazy" class="sc-fzoJus bPIkEp"/>
      </div>

      <div class="p-4 xl:p-6 space-y-4">
        <h3 class="heading heading-3">Card Title</h3>
        <p class="copy">Enabling teams to create high-quality products and experiences faster for our customers.</p>
      </div>

      <hr class="divider"/>

      <div class="p-4 xl:p-6 space-x-2">
        <button class="button button-primary-dark">Get a quote</button>
        <button class="button button-secondary-dark">More info</button>
      </div>
    </div>
  `;

  const cardList = `
    <div class="container">
      <div class="flex flex-wrap xl:flex-no-wrap gap-4">
        ${card}
        ${card}
      </div>
    </div>
  `;
</script>

<template>
  <section id="card" class="page-section bg-warmWhite40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Card</h2>
      <div>
        <h3 class="heading heading-3 mt-8 mb-6">Basic</h3>
        {@html footerlessCard}
        <CodeSnippet id="footerlessCard" snippet={footerlessCard} />
      </div>
      <div>
        <h3 class="heading heading-3 mt-8 mb-6">With footer</h3>
        {@html card}
        <CodeSnippet id="card" snippet={card} />
      </div>
      <div>
        <h3 class="heading heading-3 mt-8 mb-6">With image</h3>
        {@html imageCard}
        <CodeSnippet id="imageCard" snippet={imageCard} />
      </div>
      <div>
        <h3 class="heading heading-3 mt-8 mb-6">List of cards</h3>
        {@html cardList}
        <CodeSnippet id="cardList" snippet={cardList} />
      </div>
    </div>
  </section>
</template>
